import { render, staticRenderFns } from "./secondaryMenu.vue?vue&type=template&id=00fedcd2&scoped=true"
import script from "./secondaryMenu.vue?vue&type=script&lang=js"
export * from "./secondaryMenu.vue?vue&type=script&lang=js"
import style0 from "./secondaryMenu.vue?vue&type=style&index=0&id=00fedcd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fedcd2",
  null
  
)

export default component.exports